import Cookies from 'js-cookie';
import { setDarkTheme } from '@/dashboard/store/themeStore';

export function themeDetect() {
  const darkTheme = Cookies.get('dark_theme_enabled');
  const darkEnabled = darkTheme ? darkTheme === 'true' : window.matchMedia('(prefers-color-scheme: dark)').matches;
  setDarkTheme(darkEnabled);

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    const darkTheme = Cookies.get('dark_theme_enabled');
    const darkEnabled = darkTheme ? darkTheme === 'true' : window.matchMedia('(prefers-color-scheme: dark)').matches;
    setDarkTheme(darkEnabled);
  });
}
